import { render, staticRenderFns } from "./Tab.vue?vue&type=template&id=9e7f9e04&scoped=true"
import script from "./Tab.vue?vue&type=script&lang=ts"
export * from "./Tab.vue?vue&type=script&lang=ts"
import style0 from "./Tab.vue?vue&type=style&index=0&id=9e7f9e04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e7f9e04",
  null
  
)

export default component.exports